import React, { useRef } from 'react'

import Align from './Align.jsx'
import Text from './Text.jsx'
import useRect from '../hooks/useRect'
import usePosition from '../hooks/usePosition'

// const getBase64Image = (url) => {
//   const img = new Image()
//   img.setAttribute('crossOrigin', 'anonymous')
//   img.onload = () => {
//     const canvas = document.createElement('canvas')
//     canvas.width = img.width
//     canvas.height = img.height
//     const ctx = canvas.getContext('2d')
//     ctx.drawImage(img, 0, 0)
//     const dataURL = canvas.toDataURL('image/png')
//   }
//   img.src = url
// }

// const serializer = new XMLSerializer()

// const getBase64 = (img) => {
//   const svgElement = img
//   const { width, height } = svgElement.getBBox()

//   let clonedSvgElement = svgElement.cloneNode(true)

//   let outerHTML = clonedSvgElement.outerHTML
//   let blob = new Blob([outerHTML], { type: 'image/svg+xml;charset=utf-8' })

//   let URL = window.URL || window.webkitURL || window
//   let blobURL = URL.createObjectURL(blob)

//   let image = new Image()
//   image.onload = () => {
//     let canvas = document.createElement('canvas')
//     canvas.width = width
//     canvas.height = height
//     let context = canvas.getContext('2d')
//     // draw image in canvas starting left-0 , top - 0
//     context.drawImage(image, 0, 0, width, height)
//     //  downloadImage(canvas); need to implement
//     const dataURL = canvas.toDataURL('image/png')
//   }
//   image.src = blobURL
// }

// const getBase64_2 = (ref) => {
//   var svg = ref
//   const img = new Image()
//   img.setAttribute('crossOrigin', 'anonymous')

//   // get svg data
//   var xml = new XMLSerializer().serializeToString(svg)

//   // make it base64
//   var svg64 = window.btoa(xml)
//   var b64Start = 'data:image/svg+xml;base64,'

//   // prepend a "header"
//   var image64 = b64Start + svg64

//   // set it as the source of the img element
//   img.onload = () => {
//     const canvas = document.createElement('canvas')
//     canvas.width = img.width
//     canvas.height = img.height
//     const ctx = canvas.getContext('2d')
//     ctx.drawImage(img, 0, 0)
//     const dataURL = canvas.toDataURL('image/png')
//   }
//   img.src = image64
// }

// TODO: get base64 images to prevent cors errors while exporting
const BlockImageLabelData = ({ imageUrl, label, data, accentColor = '#13682B' }) => {
  const [Rect, rect] = useRect()
  const [nameRef, nameRect] = usePosition()
  const [scoreRef, scoreRect] = usePosition()

  // const base64 = getBase64Image(
  //   'http://commons.wikimedia.org/wiki/Special:FilePath/Instagram_logo_2016.svg?width=300'
  // )

  // const imageRef = useRef()

  // imageRef.current && getBase64_2(imageRef.current)

  return (
    <Align
      childrenRect={{
        x: 0,
        y: 0,
        width: rect.width,
        height: 400,
      }}
    >
      <svg x="0" y="0" width={'100%'} height={'100%'}>
        <Rect />
        {imageUrl ? (
          // <svg ref={imageRef} x="0" y="0" width={'100%'} height={'100%'}>
          <image href={imageUrl} x={20} y={0} width={rect.width - 40} height={rect.width} />
        ) : (
          // </svg>
          <rect x={0} y={0} width={rect.width} height={rect.width} fill="#eeeeee" />
        )}
        <Text
          gRef={scoreRef}
          y={rect.width}
          value={data}
          width={rect.width}
          textAnchor="middle"
          fontSize={64}
          fontWeight="bold"
          fill={accentColor}
        />
        <Text
          gRef={nameRef}
          y={scoreRect.y + scoreRect.height}
          value={label}
          width={rect.width}
          textAnchor="middle"
          fontSize={32}
          fill="#3D3D3D"
        />
      </svg>
    </Align>
  )
}

export default BlockImageLabelData
